import React from 'react'
import {getJwt} from '../../../hooks/useJwt'
import { REVIEWER_TYPE_EXPERT } from '../../../enums/UserRole'

export const getAvatarBackgroundImage = (expert) => `background-image:url('/api/expert/${expert.id}/picture?t=${getJwt()}&no-cache=${expert.picture}');`
export const getAvatarBackgroundWithReviewerType = (expert) =>  expert?.reviewerType === REVIEWER_TYPE_EXPERT || expert?.type === REVIEWER_TYPE_EXPERT
    ? `background-image:url('/api/expert/${expert.id}/picture?t=${getJwt()}&no-cache=${expert.picture}');`
    : `background-image:url('/api/admin/${expert.id}/picture?t=${getJwt()}&no-cache=${expert.picture}');`